import HomeShowcase from '../pages/HomeShowcase'
import NotFound from '../pages/elements/404'

export const routes = [
    {
        path:'/',
        name: 'HomeShowcase',
        component: HomeShowcase
    },
    {
        path:'*',
        name: 'NotFound',
        component: NotFound
    },
];